import {useState} from "react";

const MASK = '●●●●●●●●';

export default function StoredSecretInput({
                                              configured = false,
                                              value = '',
                                              onChange,
                                              placeholder,
                                              concealWhileEditing = false,
                                          }) {
    const [editing, setEditing] = useState(!configured);

    return <>
        <input
            className={'form-input'}
            type={'text'}
            autoComplete={'off'}
            autoCapitalize={'none'}
            spellCheck={false}
            style={concealWhileEditing && editing ? {WebkitTextSecurity: 'disc'} : undefined}
            placeholder={placeholder}
            value={configured && !editing ? MASK : value}
            onFocus={() => {
                if (configured && !editing) {
                    setEditing(true);
                    onChange('');
                }
            }}
            onBlur={() => {
                if (configured && value === '') {
                    setEditing(false);
                }
            }}
            onChange={(event) => onChange(event.target.value)}
        />
        {configured && <span className={'text-xs font-normal leading-5 text-slate-500 dark:text-slate-400'}>
            Vyplňte pouze pokud ho chcete změnit.
        </span>}
    </>;
}
